// extracted by mini-css-extract-plugin
export var cardHeader = "_u2-0";
export var reorderHandle = "_u2-3";
export var titleArea = "_u2-1";
export var titleAreaWithHandle = "_u2-2";